import {CreateLastCallError} from './CreateLastCallError.js'
import {DealerNotFoundError} from './DealerNotFoundError.js'
import {InvalidUserError} from './InvalidUserError.js'
import {LastCallAlreadyExistsError} from './LastCallAlreadyExistsError.js'
import {ShowLastCallError} from './ShowLastCallError.js'
export class LastCallErrorsFactory {
  static createLastCallError = message => new CreateLastCallError(message)

  static dealerNotFoundError = message => new DealerNotFoundError(message)

  static invalidUserError = message => new InvalidUserError(message)

  static lastCallAlreadyExistsError = message => new LastCallAlreadyExistsError(message)

  static showLastCallError = message => new ShowLastCallError(message)
}
